shvenergy.retrievequote = (function ($) {
	"use strict";

	var quoteRetrivalBlock = $(".quote-retrieval");
	const templateId = quoteRetrivalBlock.data("templateid");
	var cdnvalue = $("#cdnInput").data("value");
	const pageHasQuoteRetrievalBlock = quoteRetrivalBlock.length > 0;
	const showQuoteRetrivalBlockDelay = 1500;
	const trackingCategory = "Retrive Quote"; //used for google analytics
	const quoteResultId = shvenergy.utils.getUrlParameter("retrieveQuoteId");
	const svgArrow = `<svg focusable="false" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16">
							<use xlink:href="${cdnvalue}/dist/svgsprite/icons.svg#Arrow_No-stem_16x16"></use>
						</svg>`;

	const retrieveLpgQuoteEndpoint = '/api/retrievelpgquote/RetrieveLpgQuote/';
	const getQuoteEndpoint = '/api/retrievelpgquote/get';
	const getQuoteByIdEndpoint = '/api/retrievelpgquote/getbyquoteresultId';



	if (!pageHasQuoteRetrievalBlock && quoteResultId.length <= 0) {
		return;
	}

	var isFetchingContentStore = {
		isFetchingContent: false,
		isFetchingContentListener: function () {
			//console.log(`hello world! ${val}`);
		},
		set isFecthing(val) {
			this.isFetchingContent = val;
			this.isFetchingContentListener(val);
		},
		get isFecthing() {
			return this.isFetchingContent;
		},
		registerListener: function (listener) {
			this.isFetchingContentListener = listener;
		}
	};

	isFetchingContentStore.registerListener(function () {

		quoteRetrivalBlock.find("button[data-getquote]").prop("disabled", isFetchingContentStore.isFecthing);
		quoteRetrivalBlock.find("button[data-getquote]").find("svg").toggleClass("hide");

	});

	window.setTimeout(() => {
		quoteRetrivalBlock.addClass("isVisible");
	}, showQuoteRetrivalBlockDelay);


	//This function returns all the HTML that used to be in "RetrieveLpgQuote.cshtml"
	function retrieveLpgQuoteHtml(data) {



		let closeButtonTrackingId = "";
		if (data.CloseButtonTrackingId && data.CloseButtonTrackingId !== "") {
			closeButtonTrackingId = `id="${data.CloseButtonTrackingId}"`;
		};

		let expiresCssClass = "";
		if (data.IsExpiresTextHighlighted) {
			expiresCssClass = "warning";
		};


		let buttonTrackingId = "";
		if (data.ButtonTrackingId && data.ButtonTrackingId !== "") {
			buttonTrackingId = `id="${data.ButtonTrackingId}"`;
		};

		return `<header class="quote-retrieval__header">
            <div class="flex-container align-middle align-justify quote-retrieval__header__text">
                <strong>${data.Headline}</strong>
                <button type="button" class="suspend-button" data-suspend-getquoteform ${closeButtonTrackingId}>(${data.CloseButtonText})</button>
            </div>

            <button type="button" class="toggle-button" data-toggle-getquoteform id="${data.ToggleOpenCloseButtonTrackingId}">
                <svg focusable="false" width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" class="arrow">
                    <use xlink:href="${cdnvalue}/dist/svgsprite/icons.svg#Arrow_Down_16x16"></use>
                </svg>
            </button>
        </header>

        <div class="quote-retrieval__body">

            <div class="flex-container align-middle align-justify from-expires">

                <span class="flex-container align-middle from-price">
                    ${data.PricePreText}<strong>${data.PriceText}</strong>${data.PricePostText}
                </span>

                <span class="flex-container align-middle expires">
                    <svg focusable="false" width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
                        <use xlink:href="${cdnvalue}/dist/svgsprite/icons.svg#Clock_16x16"></use>
                    </svg>
                    <strong class="${expiresCssClass}">${data.ExpiresText}</strong>
                </span>

            </div>

            <form class="quote-retrieval__form" method="post" novalidate="novalidate">
                <p>${data.BodyCopy}</p>

                <div class="row small-collapse small-up-1">
                    <div class="column">
                        <div>
                            <label class="visuallyhidden" id="quoteRetrievalFormEmailLabel" for="quoteRetrievalFormEmail">${data.EmailPlaceholderText}</label>
                            <input type="email" name="quoteRetrievalFormEmail" id="quoteRetrievalFormEmail" aria-labelledby="quoteRetrievalFormEmailLabel" placeholder="${data.EmailPlaceholderText}" required>
                        </div>

                        <div class="error hide" id="requiredEmailErrorMessage">${data.EmailRequiredErrorMessage}</div>
                        <div class="error hide" id="invalidEmailErrorMessage">${data.EmailInvalidErrorMessage}</div>
                    </div>
                </div>


                <div class="row small-collapse small-up-1 medium-up-2">

                    <div class="column u-margin-top-small">
                        <div>
                            <label class="visuallyhidden" id="quoteRetrievalFormQuoteNumberLabel" for="quoteRetrievalFormQuoteNumber">${data.QuoteNumberPlaceHolderText}</label>
                            <input type="text" name="quoteRetrievalFormQuoteNumber" id="quoteRetrievalFormQuoteNumber" aria-labelledby="quoteRetrievalFormQuoteNumberLabel" placeholder="${data.QuoteNumberPlaceHolderText}" value="${data.QuoteNumber}" required>
                            <div class="error hide" id="requiredQuoteNumberMessage">${data.QuoteNumberRequiredErrorMessage}</div>
                        </div>
                    </div>
                    <div class="column u-text-right u-margin-top-small">

                        <button type="submit" class="button align-self-bottom" data-getquote ${buttonTrackingId}>
                            <span>${data.ButtonText}</span>
                            <svg focusable="false" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16"><use xlink:href="${cdnvalue}/dist/svgsprite/icons.svg#Arrow_No-stem_16x16"></use></svg>
                            <svg focusable="false" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16" class="loading hide"><use xlink:href="${cdnvalue}/dist/svgsprite/icons.svg#Loading_16x16"></use></svg>
                        </button>

                    </div>

                </div>

            </form>

        </div>`;
	}

	function generateApiButton(data, buttonType) {

		let type = '';
		if (buttonType === "secondary")
			type = 'button--white button--hollow';

		return `<button type="button" id="${data.TrackingId}" data-suspend data-getapi class="button ${type} u-margin-top-small" data-params='${JSON.stringify(data.ApiParameters)}' data-apiurl="${data.Url}">
						<span>${data.Text}</span>
						${svgArrow}
					</button>`;
	}

	function generateLink(data, buttonType) {

		let type = '';
		if (buttonType === "secondary")
			type = 'button--white button--hollow';

		return `<a href="${data.Url}" id="${data.TrackingId}" data-suspend class="button ${type} u-margin-top-small">
						<span>${data.Text}</span>
						${svgArrow}
					</a>`;
	}

	function generateButtonsMarkup(data) {
		let markup = '';

		let buttonType = "secondary";

		if (data.length === 1) {
			buttonType = "primary";
		}

		data.forEach(function (button) {

			switch (button.Type) {
				case "Api":
					markup += generateApiButton(button, buttonType);
					break;
				default: //  this is equal to data.Type = "Link"
					markup += generateLink(button, buttonType);
			}

			buttonType = "primary";

		});

		return markup;
	}

	function generateDetailsMarkup(details) {

		let detailsList = "";
		detailsList += `<ul class="quote-details-list">`;
		details.forEach(function (detail) {
			detailsList += `<li><span class="quote-details-list__key">${detail.Label}</span><span class="quote-details-list__value">${detail.Value}</span></li>`;
		});

		detailsList += `</ul>`;

		return detailsList;
	}

	function generateConfirmDetailsMarkup(data) {

		shvenergy.tracking.trackEvent(trackingCategory, "Modal", "Confirm details shown");

		let headline = "";
		let leftCol = "";
		let rightCol = "";
		let buttons = "";

		if (data.Header) {
			headline = `<div class="row column u-text-center">
								<h2>${data.Header}</h2>
							</div>`;
		}

		if (data.ColumnOneData) {
			leftCol = generateDetailsMarkup(data.ColumnOneData);
		}

		if (data.ColumnTwoData) {
			rightCol = generateDetailsMarkup(data.ColumnTwoData);
		}

		if (data.Buttons && data.Buttons.length > 0) {
			buttons += generateButtonsMarkup(data.Buttons);
		}



		return `<div>
						${headline}
						<div class="row">
							<div class="column small-12 medium-6 u-margin-top">
								<div class="quote-details-headline"><strong>${data.ColumnOneHeader}</strong></div>
								${leftCol}
							</div>
							<div class="column small-12 medium-6 u-margin-top">
								<div class="quote-details-headline"><strong>${data.ColumnTwoHeader}</strong></div>
								${rightCol}
							</div>
						</div>

						<div class="row column u-text-center">${buttons}</div>

					</div>`;

	}

	function generateQuoteHasExpiredMarkup(data) {

		shvenergy.tracking.trackEvent(trackingCategory, "Modal", "Quote has expired shown");

		let headline = "";
		let text = "";
		let buttons = "";

		if (data.Header) {
			headline = `<h2>${data.Header}</h2>`;
		}

		if (data.BodyText) {
			text = data.BodyText;
		}


		//if (data.Link && data.Link.Url && data.Link.Text) {
		//	button = `<a href="${data.Link.Url}" class="button button--hollow u-margin-top-small">
		//					<span>${data.Link.Text}</span>
		//					${svgArrow}
		//				</a>`;
		//}

		if (data.Buttons && data.Buttons.length > 0) {
			buttons = generateButtonsMarkup(data.Buttons);
		}

		return `<div class="u-text-center">
						
						<div class="row align-center">
							<div class="column small-12 medium-11">
								${headline}
								${text}
							</div>
						</div>

						<div class="row column">${buttons}</div>

					</div>`;
	}

	function generateErrorMarkup(data) {
		//data object
		//{
		// "Type": "Error", 
		//"Content": { 
		//	"Header": "An error has occurred", 
		//	"BodyText": "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras gravida id turpis eget laoreet. Aliquam in augue nisi. Donec lobortis nec justo vitae tristique. Sed lacus orci, lacinia id efficitur nec, mattis pellentesque tortor. Suspendisse pellentesque quis odio sit amet rhoncus.</p>", 
		//	"Buttons": [
		//			{ "Type": "Link", "Text": "Get new quote", "Url": "/testpages/wizardtool/domestic-lpg-get-a-quote" }
		//]
		//}

		shvenergy.tracking.trackEvent(trackingCategory, "Modal", "Error has occurred shown");

		let headline = "";
		let text = "";
		let buttons = "";


		if (data.Header) {
			headline = `<h2>${data.Header}</h2>`;
		}

		if (data.BodyText) {
			text = data.BodyText;
		}




		if (data.Buttons && data.Buttons.length > 0) {
			buttons += generateButtonsMarkup(data.Buttons);
		}

		return `<div class="u-text-center">
						
						<div class="row align-center">
							<div class="column small-12 medium-11">
								${headline}
								${text}
							</div>
						</div>

						<div class="row column">${buttons}</div>

					</div>`;

	}

	function renderPopup(data, options = {}) {

		let markup = "";
		const defaults = {
			replaceContent: false
		};

		const actual = $.extend({}, defaults, options || {});

		switch (data.Type) {
			case "ConfirmDetails":
				markup = generateConfirmDetailsMarkup(data.Content);
				break;
			case "QuoteHasExpiredBefore":
				markup = generateQuoteHasExpiredMarkup(data.Content);
				break;
			case "QuoteHasExpiredAfter":
				markup = generateQuoteHasExpiredMarkup(data.Content);
				break;
			default: //  this is equal to data.Type = "Error"
				markup = generateErrorMarkup(data.Content);
		}

		if (actual.replaceContent) {
			shvenergy.modal.replaceModalContent(markup);
		} else {
			shvenergy.modal.showModal(markup);
		}

	}

	function fetchApi(params, url) {


		isFetchingContentStore.isFecthing = url === getQuoteEndpoint ? true : false;
		shvenergy.modal.isLoadingStore.isLoading = true;

		let shouldReplaceContent = true;

		if (url === getQuoteEndpoint || url === getQuoteByIdEndpoint) {
			shouldReplaceContent = false;
		}

		const request = $.ajax({
			type: "POST",
			url: url,
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			data: JSON.stringify(params)
		});
		request.done(function (data) {

			if (data.Type && data.Type === "Redirect") {
				shvenergy.modal.hideModal();
				window.location.href = data.RedirectUrl;
			} else {
				renderPopup(data, { replaceContent: shouldReplaceContent });
			}


		});
		request.fail(function (jqXhr, error, errorThrown) {

			//console.log(jqXhr);
			//console.log(jqXhr.responseJSON.Message);
			//console.log(error);
			//console.log(errorThrown);

			if (jqXhr.status && jqXhr.status === 400) {
				shvenergy.modal.showModal(`Request failed: ${jqXhr.responseJSON.Message}`);
			} else {
				shvenergy.modal.showModal(`Request failed: ${errorThrown}`);
			}

		});
		request.always(function () {

			shvenergy.modal.isLoadingStore.isLoading = false;
			isFetchingContentStore.isFecthing = false;

		});

	}

	function checkForm() {

		let emailIsValid = false;
		let quoteNumberIsValid = false;

		const requiredEmailErrorMessage = $("#requiredEmailErrorMessage");
		const invalidEmailErrorMessage = $("#invalidEmailErrorMessage");
		const requiredQuoteNumberMessage = $("#requiredQuoteNumberMessage");

		requiredEmailErrorMessage.addClass("hide");
		invalidEmailErrorMessage.addClass("hide");
		requiredQuoteNumberMessage.addClass("hide");

		//E-mail
		if (shvenergy.utils.validateEmail($("#quoteRetrievalFormEmail").val())) {
			invalidEmailErrorMessage.addClass("hide");
			requiredEmailErrorMessage.addClass("hide");
			emailIsValid = true;
		} else {

			invalidEmailErrorMessage.removeClass("hide");

			if ($("#quoteRetrievalFormEmail").val().length <= 0) {
				requiredEmailErrorMessage.removeClass("hide");
				invalidEmailErrorMessage.addClass("hide");
				emailIsValid = false;
			}

		}

		//quoteNumber
		if ($("#quoteRetrievalFormQuoteNumber").val().length > 0) {
			requiredQuoteNumberMessage.addClass("hide");
			quoteNumberIsValid = true;
		} else {
			requiredQuoteNumberMessage.removeClass("hide");
			quoteNumberIsValid = false;
		}

		return emailIsValid && quoteNumberIsValid;

	}

	function getQuote(e) {
		e.preventDefault();

		if (!checkForm()) {
			return;
		}

		shvenergy.tracking.trackEvent(trackingCategory, "click", "Go to quote");

		let data = {
			quoteId: $("#quoteRetrievalFormQuoteNumber").val().trim(),
			email: $("#quoteRetrievalFormEmail").val().trim()
		};

		fetchApi(data, getQuoteEndpoint);

	}

	function suspendQuoteRetrievalBlock() {
		shvenergy.cookies.setCookie("_shvenergy_retrive_lpgquote_closed", "closed", 1);
		quoteRetrivalBlock.removeClass("isVisible");
		window.setTimeout(() => {
			quoteRetrivalBlock.remove();
			$(".page-footer__bottom").removeClass("page-footer__bottom--extrabottompadding");
		}, 310);
	}

	function setupEventHandlers() {

		$(document).on("click", "button[data-toggle-getquoteform]", function () {
			quoteRetrivalBlock.toggleClass("formIsVisible");
			quoteRetrivalBlock.find("form").slideToggle();

			var trackLabel = quoteRetrivalBlock.hasClass("formIsVisible") ? "show form" : "hide form";
			shvenergy.tracking.trackEvent(trackingCategory, "toggle form clicked", trackLabel);

		});

		$(document).on("click", "button[data-suspend-getquoteform]", function () {
			suspendQuoteRetrievalBlock();
		});

		//$("#quoteRetrievalFormEmail").on("keyup", function() {
		//	checkForm();
		//});
		//$("#quoteRetrievalFormEmail").on("keyup", function () {
		//	checkForm();
		//});

		$(document).on("click", "button[data-getquote]", function (e) {
			getQuote(e);
		});

		$(document).on("click", "[data-getapi]", function () {
			fetchApi($(this).data("params"), $(this).data("apiurl"));
		});

		$(document).on("click", "[data-suspend]", function () {
			suspendQuoteRetrievalBlock();
		});
	}

	if (pageHasQuoteRetrievalBlock && templateId !== "") {

		var cookieName = "_shvenergy_retrive_lpgquote";

		if (shvenergy.cookies.hasCookieCategoryConsent(cookieName)) {
			if (shvenergy.cookies.getCookie(cookieName)) {
				//if the enduser has given consent to the _shvenergy_retrive_lpgquote and the cookie exists

				setupEventHandlers();

				//console.log("templateId: ", templateId);

				const request = $.ajax({
					type: "GET",
					url: `${retrieveLpgQuoteEndpoint}${templateId}`,
					contentType: "application/json; charset=utf-8",
					dataType: "json"
				});
				request.done(function (data) {

					if (data.Status && data.Status === "true") {

						console.log(data);

						quoteRetrivalBlock.html(retrieveLpgQuoteHtml(data));
						quoteRetrivalBlock.attr("hidden", false);
						$(".page-footer__bottom").addClass("page-footer__bottom--extrabottompadding");

						if (data.Position && data.Position !== "") {
							quoteRetrivalBlock.addClass(data.Position);
						}


					} else {
						//console.log("FALSE");
					}


				});
				request.fail(function (jqXhr, error, errorThrown) {

					//console.log(jqXhr);
					//console.log(jqXhr.responseJSON.Message);
					//console.log(error);
					//console.log(errorThrown);

					if (jqXhr.status && jqXhr.status === 400) {
						shvenergy.modal.showModal(`Request failed: ${jqXhr.responseJSON.Message}`);
					} else {
						shvenergy.modal.showModal(`Request failed: ${errorThrown}`);
					}

				});
				request.always(function () {
					//do nothing

					if (quoteResultId && quoteResultId.length > 0) {
						let data = {
							QuoteResultId: quoteResultId
						};
						fetchApi(data, getQuoteByIdEndpoint);
					}
				});

			}
		}
	}


})(jQuery);